import React from 'react';
import PropTypes from 'prop-types';

import './ApexLegendsRankPicker.sass';

import { injectIntl } from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({ collapsed: '(max-width: 767px)' }, { collapsed: false })
export default class ApexLegendsRankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 0;
  static maxValue = 50000;

  static getDefaultValue = () => [0, 13000];

  static marks = {
    1000: (
      <span>
        1000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--bronze">Bronze</span>
      </span>
    ),
    5000: (
      <span>
        5000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--silver">Silver</span>
      </span>
    ),
    9000: (
      <span>
        9000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--gold">Gold</span>
      </span>
    ),
    13000: (
      <span>
        13000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--platinum">Platinum</span>
      </span>
    ),
    17000: (
      <span>
        17000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--diamond">Diamond</span>
      </span>
    ),
    21000: (
      <span>
        21000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--master">Master</span>
      </span>
    ),
    50000: (
      <span>
        50000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--predator">Possible Predator</span>
      </span>
    ),
  };

  render() {
    const { intl, collapsed, value, onChange } = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({
                id: 'section.product.rating.current',
              })}
              min={ApexLegendsRankPicker.minValue}
              max={ApexLegendsRankPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([newValue, value[1]])}
            />
          </div>

          <div className="range-inputs__divider" />

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({ id: 'section.product.wanted' })}
              min={ApexLegendsRankPicker.minValue}
              max={ApexLegendsRankPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([value[0], newValue])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-apex"
              step={500}
              min={ApexLegendsRankPicker.minValue}
              max={ApexLegendsRankPicker.maxValue}
              marks={ApexLegendsRankPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/apexLegends/ApexLegendsRankPicker.js